import { useNavigate } from 'react-router-dom';
import CreateUserForm from '@/components/forms/CreateUserForm';
import { useCreateUser } from '@/hooks';
import { CreateUserRequest } from '@/types';

const CreateUser = () => {
  const navigate = useNavigate();
  const createUserMutation = useCreateUser();

  const handleSuccess = async (data: CreateUserRequest) => {
    const response = await createUserMutation.mutateAsync(data);
    const createdUserId = response.user?.id;

    if (createdUserId) {
      // Navigate with query parameter to auto-open credits modal
      navigate(`/users?openCredits=${createdUserId}`);
    } else {
      navigate('/users');
    }
  };

  const handleCancel = () => {
    navigate('/users');
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <CreateUserForm
          isSubmitting={createUserMutation.isPending}
          onSuccess={handleSuccess}
          onCancel={handleCancel} />
      </div>
    </div>
  );
};

export default CreateUser;
